import React from 'react';
import { services, notOffered } from '../data/mock';
import { Building2, TreeDeciduous, Fence, Wrench, Sparkles, Snowflake, XCircle } from 'lucide-react';

const iconMap = {
  Building2,
  TreeDeciduous,
  Fence,
  Wrench,
  Sparkles,
  Snowflake,
};

const Services = () => {
  return (
    <section id="leistungen" className="py-12 md:py-16 lg:py-24 bg-[#FAFAFF]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block text-[#FFD700] font-semibold text-xs sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">
            Was wir bieten
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#1E4D2B] mb-4 sm:mb-6">
            Unsere Leistungen
          </h2>
          <p className="text-[#2D5F3A] text-base sm:text-lg max-w-2xl mx-auto px-4 sm:px-0">
            Professionelle Dienstleistungen für Ihr Zuhause und Ihre Immobilie
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-[32px] p-6 sm:p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-[#D4DCC9]/30"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#E8EDE4] rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#FFD700] transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 sm:w-7 sm:h-7 text-[#1E4D2B]" />
                  )}
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-[#1E4D2B] mb-2 sm:mb-3">
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-[#2D5F3A] leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Not Offered Section */}
        <div className="bg-[#E8EDE4] rounded-[32px] p-6 sm:p-8 max-w-3xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 text-center sm:text-left">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center flex-shrink-0">
              <XCircle className="w-6 h-6 text-[#807979]" />
            </div>
            <div className="w-full">
              <h3 className="text-lg font-semibold text-[#1E4D2B] mb-2 sm:mb-3">
                Transparenz ist uns wichtig
              </h3>
              <p className="text-[#2D5F3A] mb-4 text-sm sm:text-base">
                Folgende Arbeiten bieten wir <strong>nicht</strong> an:
              </p>
              <div className="flex flex-col sm:flex-row sm:flex-wrap items-center sm:items-start justify-center sm:justify-start gap-2">
                {notOffered.map((item, index) => (
                  <span
                    key={index}
                    className="inline-flex items-center gap-1.5 bg-white px-4 py-2 rounded-full text-sm text-[#807979] font-medium"
                  >
                    <XCircle className="w-4 h-4" />
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
